import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LeftOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Notiflix from "notiflix";
import { connect, useDispatch } from "react-redux";

import {
  DatePicker,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Col,
  Form,
  Table,
  Tooltip,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin,
  Statistic,
  Collapse,
  Tag,
} from "antd";

//OTHER IMPORTS
import dayjs from "dayjs";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { labelConfig, staticConfig, apiConfig } from "../../operations.config";
import { rightAction } from "../../../../redux/actions";
import CustomButton from "../../../../components/custom/CustomButton";
import amountFieldsConfig from "../../../../config/amountFields.json";

const { Text } = Typography;
const { Panel } = Collapse;
const dateFormat = "YYYY-MM-DD";

const DetailCheckerInbox = (props) => {
  const { userData, pageTitleParam } = props;
  const { session } = userData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [checkerInboxDetails, setCheckerInboxDetails] = useState([]);
  const [commandRows, setCommandRows] = useState([]);
  const [entity,setEntity] =  useState([])
  useEffect(() => {
    getDetailById();
  }, []);


  function getDetailById() {
    const url = `${apiConfig.Audits}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setEntity(res)
        setCheckerInboxDetails(objList);
        const commands = res?.commandAsJson;
        let commandData = {};
        console.log(commands);
        if (commands) {
          if (typeof commands === "string") {
            try {
              commandData = JSON.parse(commands);
            } catch (err) {
              console.error("Error parsing commands:", err);
            }
          } else if (typeof commands === "object") {
            commandData = commands;
          }
          const rows = Object.entries(commandData).map(
            ([key, value], index) => ({
              key: index.toString(),
              command: key,
              value: value,
            })
          );
          setCommandRows(rows);
        }

        [cnt.RIGHT_DELETE_BTN, cnt.RIGHT_APPROVE_BTN, cnt.RIGHT_REJECT_BTN].map(
          (items) => {
            dispatch({ type: items });
          }
        );
      }
    });
  }

  function JsonToTable({ data }) {
    // ARRAY
    if (Array.isArray(data)) {
      return (
        <Collapse size="small" ghost>
          <Panel header={`Array (${data.length})`} key="array">
            {data.map((item, index) => (
              <div key={index} style={{ marginBottom: 12 }}>
                <Tag color="blue">Item {index + 1}</Tag>
                <JsonToTable data={item} />
              </div>
            ))}
          </Panel>
        </Collapse>
      );
    }

    // OBJECT
    if (typeof data === "object" && data !== null) {
      const rows = Object.entries(data).map(([key, value], index) => ({
        key: index,
        field: key,
        value,
      }));

      return (
        <Table
          size="small"
          bordered
          pagination={false}
          dataSource={rows}
          columns={[
            {
              title: "Field",
              dataIndex: "field",
              render: (text) => formatLabel(text),
              width: "35%",
            },
            {
              title: "Value",
              dataIndex: "value",
              // render: (value) => <JsonValue value={value} />,
              render: (value, record) => (
                <JsonValue value={value} field={record.field} />
              ),
            },
          ]}
        />
      );
    }

    return <JsonValue value={data} />;
  }

  function JsonValue({ value, field }) {
    // Handle nested objects / arrays
    if (Array.isArray(value) || (typeof value === "object" && value !== null)) {
      return <JsonToTable data={value} />;
    }

    // Amount formatting
    if (field && typeof value === "number") {
      const allAmountFields = Object.values(
        amountFieldsConfig.currencyFieldRegistry
      ).flatMap((config) => config.amountFields);

      if (
        allAmountFields.includes(field) ||
        field.toLowerCase().includes("amount")
      ) {
        return value.toLocaleString();
      }
    }

    if (value === true) return <Tag color="green">True</Tag>;
    if (value === false) return <Tag color="red">False</Tag>;
    if (value === null) return <Tag>Null</Tag>;

    return String(value);
  }

  function formatLabel(text) {
    if (!text) return "";

    return (
      text
        // insert space before capital letters
        .replace(/([A-Z])/g, " $1")
        // handle acronyms/numbers better
        .replace(/\s+/g, " ")
        .trim()
        // capitalize first letter
        .replace(/^./, (str) => str.toUpperCase())
    );
  }

  const columns = [
    {
      title: "Command",
      dataIndex: "command",
      render: (text) => formatLabel(text),
      width: "35%",
    },
    {
      title: "Value",
      dataIndex: "value",
      render: (value, record) => (
        <JsonValue value={value} field={record.command} />
      ),
    },
  ];

  function onCancel() {
    navigate("/sms0800");
  }

  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: checkerInboxDetails ? checkerInboxDetails.id : "Not Available",
    },
    {
      key: "2",
      label: labelConfig.status,
      children: checkerInboxDetails
        ? checkerInboxDetails.processingResult
        : "Not Available",
    },
    {
      key: "3",
      label: labelConfig.user,
      children: checkerInboxDetails
        ? checkerInboxDetails.maker
        : "Not Available",
    },
    {
      key: "4",
      label: labelConfig.action,
      children: checkerInboxDetails
        ? checkerInboxDetails.actionName
        : "Not Available",
    },

    {
      key: "5",
      label: labelConfig.entity,
      children: checkerInboxDetails
        ? checkerInboxDetails.entityName
        : "Not Available",
    },

    {
      key: "6",
      label: labelConfig.resourceId,
      children: checkerInboxDetails
        ? checkerInboxDetails.resourceId
        : "Not Available",
    },

    {
      key: "7",
      label: labelConfig.date,
      children: checkerInboxDetails
        ? BOM.DateTime(checkerInboxDetails.madeOnDate, "only-date")
        : "Not Available",
    },

    {
      key: "8",
      label: checkerInboxDetails?.officeName ? labelConfig.office : "",
      children: checkerInboxDetails
        ? checkerInboxDetails.officeName
        : "Not Available",
    },
  ];

  const handleOnDelete = () => {
    let action = "Delete  ";
    let checkerName = "Action ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "delete" };

        let body = {
          method: "DELETE",
          session,
          params,
        };

        const url = `${apiConfig.MakerCheckers}/${state.id}`;

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCheckerMsg);
            navigate("/sms0800");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  function handleOnApprove() {
    let action = "Approve ";
    let checkerName = "Action ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "approve" };

        let body = {
          method: "POST",
          session,
          params,
        };

        let url;

        if(entity.entityName === "SECURITYMASTER" || entity.entityName === "FIXED_INCOME_PRODUCT"){
          url = `${apiConfig.MakerCheckersTreasury}/${state.id}`;
        }else{
          url = `${apiConfig.MakerCheckers}/${state.id}`;
        }

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveCheckerMsg);
            navigate("/sms0800");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  }

  function handleOnReject() {
    let action = "Reject ";
    let checkerName = "Action ";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + checkerName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = {
          command: "reject",
        };

        let body = {
          method: "POST",
          session,
          params,
        };

        const url = `${apiConfig.MakerCheckers}/${state.id}`;

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectCheckerMsg);
            navigate("/sms0800");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onDelete={handleOnDelete}
      onApprove={() => handleOnApprove()}
      onReject={() => handleOnReject()}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailCheckerInbox}
        pageItems={staticConfig.detailCheckerInboxBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical">
            <Row>
              <Col span={24}>
                <Descriptions
                  bordered
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
                  style={{ marginTop: 10, marginBottom: 20 }}
                  items={items}
                />
              </Col>
            </Row>

            <Divider />

            <Table columns={columns} dataSource={commandRows} />

            <Row>
              <Divider />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default DetailCheckerInbox;
